import React from 'react';
import { FAQ } from '@/components/landing/landingTemplate/FAQ';
import { ToolsExplorer } from '@/components/landing/landingTemplate/ToolsExplorer';
import { TryLift } from '@/components/landing/landingTemplate/TryLift';
import { Reviews } from '@/components/landing/reusableSections';
import { useTranslationContext } from '@/context/translation';
import {
	useLandingShownEvent,
	useSendToAmplitudeScrolledPercent,
	useTranslationWithLocale,
} from '@/hooks';
import { landingToolsConfig } from '@/data/landingConfig/landingToolsConfig';
import { reviewsLanding } from '@/data/reviewsData';
import {
	AMPLITUDE_EVENTS,
	LANDING_AMPLITUDE_EVENTS,
	LOCAL_STORAGE_KEYS,
} from '@/constants';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_Tools } from './schemaObject';

interface Props {}
const Tools: React.FC<Props> = () => {
	const { locale, translations } = useTranslationContext();
	const { t } = useTranslationWithLocale(
		landingToolsConfig.translationLocale,
		locale,
		translations?.[landingToolsConfig.translationLocale] as
			| Record<string, unknown>
			| undefined,
	);
	const { t: tReviews } = useTranslationWithLocale(
		'landing-reviews',
		locale,
		translations?.['landing-reviews'] as Record<string, unknown> | undefined,
	);
	const { t: tShared } = useTranslationWithLocale(
		'sharedLandingData',
		locale,
		translations?.sharedLandingData as Record<string, unknown> | undefined,
	);

	useSendToAmplitudeScrolledPercent(
		[50, 75, 100],
		LOCAL_STORAGE_KEYS.EMAIL_MARKETING_SCROLLED_POINTS,
		AMPLITUDE_EVENTS.WEBAPP_LANDING_SCROLLED,
		{ type: LANDING_AMPLITUDE_EVENTS.ALL_TOOLS },
	);

	useLandingShownEvent({ type: LANDING_AMPLITUDE_EVENTS.ALL_TOOLS });

	return (
		<>
			<AggregateSchema schema={schemaObject_Tools} />

			<ToolsExplorer data={landingToolsConfig.hero} t={t} />
			<Reviews t={tReviews} data={reviewsLanding} />
			<FAQ data={landingToolsConfig.faq} t={t} />
			<TryLift data={landingToolsConfig.tryLift} t={tShared} />
		</>
	);
};

export default Tools;
